export const initialArguments = {
  preload: false
}